import { render, staticRenderFns } from "./FloatChat.vue?vue&type=template&id=4de7f366&scoped=true&"
import script from "./FloatChat.vue?vue&type=script&lang=js&"
export * from "./FloatChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatChat.vue?vue&type=style&index=0&id=4de7f366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de7f366",
  null
  
)

export default component.exports